module.exports = __webpack_public_path__ + "img/lupa.87322cd3.svg";